import { render } from "./StepWizard6.vue?vue&type=template&id=69a47eb2"
import script from "./StepWizard6.vue?vue&type=script&lang=js"
export * from "./StepWizard6.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__